import TripChangeNotificationPage from "./TripChangeNotificationPage";

export default TripChangeNotificationPage;
